import { render, staticRenderFns } from "./componentUserRolesAdd.vue?vue&type=template&id=068bf732&scoped=true"
import script from "./componentUserRolesAdd.vue?vue&type=script&lang=js"
export * from "./componentUserRolesAdd.vue?vue&type=script&lang=js"
import style0 from "./componentUserRolesAdd.vue?vue&type=style&index=0&id=068bf732&lang=css"
import style1 from "./componentUserRolesAdd.vue?vue&type=style&index=1&id=068bf732&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068bf732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('068bf732')) {
      api.createRecord('068bf732', component.options)
    } else {
      api.reload('068bf732', component.options)
    }
    module.hot.accept("./componentUserRolesAdd.vue?vue&type=template&id=068bf732&scoped=true", function () {
      api.rerender('068bf732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/componentUserRoles/componentUserRolesAdd.vue"
export default component.exports